export default __webpack_public_path__ + "static/media/edit-icon.50f791fa.svg";